import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { voicesTypeControl } from '../../../types/audioType';
import { sub1_act1_01, sub1_act1_02, sub1_act1_03, sub1_act1_04 } from '../../../assets/tema8';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	win: 12
};

const infoArray = [
	{
		id: 1,
		title: "Integridad física del trabajador.",
		img: sub1_act1_01
	},
	{
		id: 2,
		title: "Continuidad de las operaciones",
		img: sub1_act1_02
	},
	{
		id: 3,
		title: "Imagen de la compañía",
		img: sub1_act1_03
	},
	{
		id: 4,
		title: "Patrimonio de la empresa",
		img: sub1_act1_04
	},
]

export const Theme8SubtopicOneActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema8.activities.subtema1], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 8 sub 1 act 1");
			ObserverEmitter.emit(EVENTS.tema8.topic1.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a01)
	})

	const [numberInfoClient, setNumberInfoClient] = useState(0)

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema8.topic1.initScene, 1);
						setNumberInfoClient(0)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1:  Requisitos esenciales.' />
					<DialogBarNew
						dialog={`Nos encontramos en un OXXO y aquí te presentaré los temas relevantes sobre nuestro equipo de Protección Patrimonial.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1. Protección patrimonial"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Recuerda que por cada misión que aparezca obtendrás puntos que miden tus conocimientos de los temas. Ya estas a punto de convertirte en un excelente Colaborador en Tienda.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Lo primero qué tienes que saber sobre Protección Patrimonial OXXO. Es que se enfocan en la protección de nuestros Colaboradores, así como de la reputación y el patrimonio de la compañía. `}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a04)
							ObserverEmitter.emit(EVENTS.characterAnimations.pensativo);
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Promoviendo los valores, el cumplimiento al Código de Ética y la Cultura de la Legalidad.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Los principales enfoques de Protección Patrimonial son: proteger la integridad física del trabajador, asegurar la continuidad de las operaciones, mantener la buena imagen de la compañía y resguardar el patrimonio de la empresa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a06)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Observemos los principales enfoques de Protección Patrimonial.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a07)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{[
				steps.dialogSeven,
				steps.dialogEight,
				steps.dialogNine,
				steps.dialogTen
			].includes(uiToShow) && (
					<>
						<div className='h-full w-full fixed z-40 bg-[#00000074] flex justify-center items-center'>
							<div className="w-[176px] h-[220px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
								<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
									<p className="text-white text-[10px] md:text-[16px]">{infoArray[numberInfoClient].title}</p>
								</div>
								<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
									<div className="w-full h-full py-3">
										<img className="h-full w-full object-contain" src={infoArray[numberInfoClient].img} alt="client" />
									</div>
								</div>
							</div>
						</div>
					</>
				)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Proteger al personal de daños intencionales y no intencionales.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a08)
							setNumberInfoClient(1)
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`Asegurar que las operaciones continúen, previniendo riesgos del entorno.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a09)
							setNumberInfoClient(2)
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Mantener la buena imagen de la Empresa con sus acciones dentro y fuera de la misma.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T8.subtema1.actividad1.sub1a10)
							setNumberInfoClient(3)
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Resguardar el patrimonio de la Empresa para prevenir acciones que afecten su operación.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Ahora dominas los principales enfoques de Protección Patrimonial."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema8.activities.subtema1
								})
							);
							navigator("/home8/tema8/subtema1/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}
